<div class="docs">

    <!-- Upload zone -->
    <div class="upload-block">

        <ngfFormData [files]="files" postName="file" [(FormData)]="uploadFormData"></ngfFormData>

        <div *ngIf="files.length === 0"
             ngfDrop selectable="1"
             [(validDrag)]="validComboDrag"
             [(files)]="files"
             [(dragFiles)]="dragFiles"
             class="dropzone"
             [class.dropzone--valid]="validComboDrag === true"
             [class.dropzone--invalid]="validComboDrag === false"
             (filesChange)="lastFileAt = getDate()">

            <span class="dropzone-icon" aria-hidden="true">
                <svg viewBox="0 0 32 32" fill="none" stroke="#00558c" stroke-width="2"
                     stroke-linecap="round" stroke-linejoin="round">
                    <path d="M8 22a5 5 0 0 1 .5-9.95A7 7 0 0 1 22 12a5 5 0 0 1 1 9.9"/>
                    <path d="M16 14v10"/>
                    <path d="M12 18l4-4 4 4"/>
                </svg>
            </span>
            <p class="dropzone-title">Haga clic o arrastre para adjuntar un documento</p>
            <p class="dropzone-helper">PDF, WORD, Excel de menos de 500MB</p>
        </div>

        <div class="file-pill" *ngIf="files.length > 0 && checkFile()">
            <span class="file-pill-icon" aria-hidden="true">
                <svg viewBox="0 0 20 20" fill="none" stroke="#00558c" stroke-width="1.5"
                     stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6z"/>
                    <path d="M12 2v4h4"/>
                </svg>
            </span>
            <span class="file-pill-name">{{ files[0].name }}</span>
            <span class="file-pill-size">{{ files[0].size / 1024 / 1024 | number: ".2" }} MB</span>

            <button type="button" class="file-pill-btn file-pill-btn--upload"
                    [disabled]="running"
                    (click)="onUpload()"
                    aria-label="Subir archivo">
                <span class="file-pill-spinner" *ngIf="running" aria-hidden="true"></span>
                <svg *ngIf="!running" viewBox="0 0 16 16" fill="none" stroke="currentColor"
                     stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M8 13V3"/>
                    <path d="M3 8l5-5 5 5"/>
                </svg>
            </button>

            <button type="button" class="file-pill-btn file-pill-btn--remove"
                    (click)="files.splice(0, 1)"
                    aria-label="Quitar archivo">×</button>
        </div>

    </div>

    <!-- Documents table -->
    <div class="docs-table-wrap" *ngIf="documents && documents.length > 0">
        <table class="docs-table">
            <thead>
                <tr>
                    <th class="th-date" (click)="orderDocuments(true)">
                        <span>Fecha inspección</span>
                        <span class="sort-arrow"
                              [class.sort-arrow--asc]="orderDesc"
                              [class.sort-arrow--desc]="!orderDesc"
                              aria-hidden="true"></span>
                    </th>
                    <th>Documento</th>
                    <th>Formato</th>
                    <th class="th-action">Acción</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let d of documents">
                    <td>{{ d.creationDate | date: 'dd/MM/yyyy' }}</td>
                    <td>
                        <a class="doc-name" (click)="onGetEventFile(d)">{{ d.name }}</a>
                    </td>
                    <td>
                        <span class="format-badge">{{ d.format }}</span>
                    </td>
                    <td class="td-action">
                        <button type="button" class="action-btn"
                                (click)="onGetEventFile(d)"
                                aria-label="Descargar documento">
                            <svg viewBox="0 0 16 16" fill="none" stroke="#00558c"
                                 stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"
                                 aria-hidden="true">
                                <path d="M8 3v8"/>
                                <path d="M3 8l5 5 5-5"/>
                                <path d="M3 14h10"/>
                            </svg>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="empty" *ngIf="documents && documents.length === 0">
        <p>No hay documentos adjuntos en este parte.</p>
    </div>

</div>
